import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Avatar, Button, Card, Col, Modal, Radio, Row, Select, Space, Spin } from 'antd';
import CorrectSvg from '../../assets/images/CorrectSvg';
import InputNumberComponent from '../../components/input/InputNumberComponent';
import TextAreaComponent from '../../components/input/TextAreaComponent';
import UserProSvg from '../../assets/images/UserProSvg';
import HistorySvg from '../../assets/images/HistorySvg';
import { renderMemberStatusBadge } from '../../utils/memberStatusUtils';
import { getDataRequest, postDataRequest, putDataRequest } from '../../api/serviceMethods';
import { MEMBER_SUBSCRIPTION_URL, MEMBER_URL } from '../../api/URLs';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatDateUTC, formatDateTime } from '../../utils/dateFormatUtils';
import HeaderDetailComponent from '../../components/header/headerDetailComponent';
import InputMask from 'react-input-mask';
import { addDays, format } from 'date-fns';
import MessageConfirmModal from '../../components/messageModal/MessageConfirmModal';
import emptyImage from "../../assets/images/image.jpeg"
import DateRangeComponent from '../../components/date/DateRangeComponent';
import InputComponent from '../../components/input/InputComponent';
import { validateEmail } from '../../utils/Validate';

function UserDetailPage({ modalOpen, setModalOpen }) {
  const { t } = useTranslation();
  const location = useLocation();
  const [btnDisable, setBtnDisable] = useState(false)
  const [loading, setLoading] = useState(false)
  const [userDetails, setUserDetails] = useState(null)
  const [modalOpenNew, setModalOpenNew] = useState(false)
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false)
  const [isChange, setIsChange] = useState(false);
  const messageModalRef = useRef("");
  const params = new URLSearchParams(location.search);
  const [dates, setDates] = useState([null, null]);
  let userDetailId = params.get('id');
  const [dataObj, setDataObj] = useState({
    setMembership: "manually",
    remark: "",
    manually: "",
    manuallyDate: ""
  })
  const [dataObjectNew, setDataObjectNew] = useState({
    phone: {
      countryCode: "852",
      number: ""
    },
    email: ""
  });

  const onChange = (e) => {
    setDataObj((membership) => ({
      ...membership,
      setMembership: e.target.value,
    }));
  };
  useEffect(() => {
    const hasValue = Boolean(dataObj.manually || (dates && (dates[0] || dates[1])));
    const hasRemark = Boolean(dataObj.remark && dataObj.remark.trim());
    if (hasValue && hasRemark) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [dataObj, dates]);

  const addNewValue = async (data) => {
    setDataObjectNew({
      phone: {
        countryCode: !data?.phone?.number ? "852" : `${data && data.phone && data.phone.countryCode}`,
        number: !data?.phone?.number ? "" : data && data.phone && data.phone.number,
      },
      email: data && data?.email
    })
  }

  useEffect(() => {
    setIsSubmit(false)
    addNewValue(userDetails && userDetails)
  }, [userDetails, modalOpenNew])

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    if(!dataObjectNew?.phone?.number && !dataObjectNew?.email || dataObjectNew?.email && !validateEmail(dataObjectNew?.email)) {
      return false;
    }
    try {
      const memberPayload = {
        phone: !dataObjectNew?.phone?.number ? null : {
          countryCode: dataObjectNew && dataObjectNew.phone && dataObjectNew.phone.countryCode,
          number: isChange && typeof dataObjectNew?.phone?.number === 'string'
            ? dataObjectNew.phone.number.replace(/[^0-9]/g, '')
            : dataObjectNew?.phone?.number || '',
        },
        email: dataObjectNew?.email ? dataObjectNew?.email : null
      }
      setLoading(true);
      await putDataRequest(`${MEMBER_URL}/${userDetailId} `, memberPayload)
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            messageModalRef?.current?.showSuccessConfirmsAutoClose(t("Updated Successfully"), () => { 
              setModalOpenNew(false)
            }, "", true);
            fetchUserDetails(userDetailId)
          } else {
            messageModalRef?.current?.showWarningConfirmsAutoClose(res && res.message, () => { }, "", true);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err)
          setLoading(false);
          messageModalRef?.current?.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || err && err.message || "Server Error!", () => { }, "", true);
        });
    } catch (error) {
      console.log("error", error)
      setLoading(false);
    }
  }

  const fetchUserDetails = async (userDetailId) => {
    try {
      setLoading(true); // Start loading
      const memberData = await getDataRequest(`${MEMBER_URL}/${userDetailId}`);
      if (memberData.status === 200) {
        setUserDetails(memberData.data); // Update user details
      }
    } catch (err) {
      console.error("Error fetching user details:", err);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    if (userDetailId) {
      fetchUserDetails(userDetailId); // Call the function when `userDetailId` changes
    }
  }, [userDetailId]);


  const phoneData = [
    {
      label: "+852",
      value: "852"
    },
    {
      label: "+86",
      value: "86"
    }
  ]

  const currentDate = new Date()
  function calculateDatePayload(startDate, daysToAdd) {
    const targetDate = addDays(new Date(startDate), daysToAdd);
    const formattedDate = format(targetDate, 'yyyy-MM-dd HH:mm');
    return formattedDate;
  }

  const handleSubmitMembership = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    if (!dataObj.remark || !dataObj.remark.trim()) {
      return false;
    }
    try {
      let startTS = "";
      let endTS = "";
      if (dataObj.setMembership === "manually") {
        const days = parseInt(dataObj.manually, 10) || 0;
        startTS = moment.utc().format('YYYY-MM-DD');
        endTS = moment.utc().add(days, 'days').format('YYYY-MM-DD');
      } else {
        startTS = moment.utc(dates[0]).format('YYYY-MM-DD');
        endTS = moment.utc(dates[1]).format('YYYY-MM-DD');
      }

      const memberPayload = {
        memberId: userDetailId,
        // "plan": "super", // super | pro // optional default pro
        period: {
          startTS,
          endTS,
        },
        remark: dataObj.remark.trim()
      }
      setLoading(true);
      await postDataRequest(`${MEMBER_SUBSCRIPTION_URL}`, memberPayload)
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            messageModalRef.current.showSuccessConfirmsAutoClose(res && res.message, () => { 
              setModalOpen(false)
            }, "", true);
            setIsSubmit(false)
            setDataObj({
              setMembership: "manually",
              remark: "",
              manually: "",
              endTS: "",
            });
            setDates("")
            fetchUserDetails(userDetailId)
          } else {
            messageModalRef.current.showWarningConfirmsAutoClose(res && res.message, () => { }, "", true);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err)
          setLoading(false);
          messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || err && err.message || "Server Error!", () => { }, "", true);
        });
    } catch (error) {
      console.log("error", error)
      setLoading(false);
    }
  }
  const address = `${userDetails?.province || ""} ${userDetails?.city || ""}`.trim();

  useEffect(() => {
    if (modalOpenNew) {
      fetchUserDetails(userDetailId)
    }
  }, [modalOpenNew]);

  // Membership periods (source of truth from the backend): { startTS, endTS, duration } or null
  const freePlan = userDetails?.plans?.free || null;
  const proPlan = userDetails?.plans?.pro || null;
  const superPlan = userDetails?.plans?.super || null;
  const proIsLive = Boolean(proPlan?.endTS && moment(proPlan.endTS).isSameOrAfter(moment().startOf('day')));
  // The plan that gives the member their current memberType
  const currentPlan = userDetails?.memberType === "VIP"
    ? superPlan
    : userDetails?.memberType === "pro"
    ? proPlan
    : userDetails?.memberType === "trial"
    ? freePlan
    : null;

  const handleOpenManualActivation = () => {
    if (proIsLive) {
      messageModalRef.current.showWarningConfirmsAutoClose(t("pro_already_active_warning"), () => { }, "", true);
      return;
    }
    setModalOpen(true);
  };

  return (
    <HeaderDetailComponent
      onClick1={handleOpenManualActivation}
      bntTitle={t('Modify Information')}
      bntTitle1={t('Manually Activate Membership')}
      backgroundColor="#f8e2e8"
      border="1px solid #e72158"
      isHide="view"
      onClick={() => navigate('/member')}
      backTitle={t("User Details")}
      hideTitle="userDetails"
      modalOpenNew={modalOpenNew}
      setModalOpenNew={setModalOpenNew}
    >
      <Spin spinning={loading}>
        <div className='container newDetail'>
          <p className='userTitle'>{t("Basic Information")}</p>
          <Card style={{ width: "100%" }}>
            <div className='d-flex'>
              <Avatar
                src={userDetails && userDetails.picUrl ? userDetails.picUrl : emptyImage}
                style={{
                  height: "48px",
                  width: "48px"
                }}
              >
                {userDetails && !userDetails.picUrl ? !userDetails.picUrl : emptyImage}
              </Avatar>
              <div style={{ marginLeft: "1rem", display: "flex", alignItems: "center" }}>
                {renderMemberStatusBadge(userDetails, t)}
              </div>
            </div>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('User Id')}:</Col>
              <Col className="text-capitalize">{userDetails && userDetails.memberId}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('Phone Number')}:</Col>
              <Col className="text-capitalize">{!userDetails?.phone?.number ? "N/A" : <>{`+${userDetails && userDetails.phone && userDetails.phone.countryCode}`} {userDetails && userDetails.phone && userDetails.phone.number}</>}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('employee_email')}:</Col>
              <Col className="">{userDetails && userDetails.email ? userDetails && userDetails.email : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('fullName')}:</Col>
              <Col className="text-capitalize">{userDetails && userDetails.name ? userDetails && userDetails.name : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('gender')}:</Col>
              <Col className="text-capitalize">{userDetails && userDetails.sex ? t(userDetails && userDetails.sex) :"N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('address')}:</Col>
              <Col className="text-capitalize">{address ? address : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('user category')}:</Col>
              <Col className="text-capitalize">{userDetails && userDetails.category ? t(userDetails && userDetails.category) : "N/A"}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('Register Time')}:</Col>
              <Col className="text-capitalize">{userDetails && formatDateTime(userDetails.createdTS)}</Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>{t('Last Login Time')}:</Col>
              <Col className="text-capitalize">{userDetails && formatDateTime(userDetails.lastLogin)}</Col>
            </Row>
          </Card>
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
            <p className='userTitle pt-3'>{t("Member Information")}</p>
            <div
              style={{ cursor: "pointer" }}
              title={t("Member History")}
              onClick={() => navigate(`/membership/details?id=${userDetailId}`)}
            >
              <HistorySvg />
            </div>
          </div>
          <Card className='mb-5' style={{ width: "100%" }}>
            <Row align="middle">
              <Col span={6} className='userLabel'>{t('Membership Type')}:</Col>
              <Col className="text-capitalize">
                {userDetails?.memberType === "VIP"
                  ? t("Super membership")
                  : userDetails?.memberType === "pro"
                  ? t("Normal membership")
                  : userDetails?.memberType === "trial"
                  ? t("Free trial")
                  : t("No membership")}
              </Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>
                {userDetails?.memberType === "trial" ? t('Free trial start time') : t('Member Activation Time')}:
              </Col>
              <Col className="text-capitalize">
                {currentPlan?.startTS ? formatDateUTC(currentPlan.startTS) : "N/A"}
              </Col>
            </Row>
            <Row align="middle" className='mt-3'>
              <Col span={6} className='userLabel'>
                {userDetails?.memberType === "trial" ? t('Free trial end time') : t('Member Expiration Time')}:
              </Col>
              <Col className="text-capitalize">
                {currentPlan?.endTS ? formatDateUTC(currentPlan.endTS) : "N/A"}
              </Col>
            </Row>
          </Card>
        </div>
        <Modal
          title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <UserProSvg />
              <span style={{ marginLeft: "10px" }}>{t('Manually Activate Membership')}</span>
            </div>
          }
          centered
          width={700}
          open={modalOpen}
          className='custom-modal'
          onOk={() => setModalOpen(false)}
          onCancel={() => {
            setModalOpen(false)
            setDataObj({
              setMembership: "manually",
              remark: "",
              manually: "",
              endTS: "",
            });
            setDates("")
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
          okButtonProps={{ style: { display: "none" } }}
        >
          <Spin spinning={loading}>
          <Row className='d-flex align-items-center' style={{ paddingLeft: "80px", paddingTop: "20px", paddingBottom: "15px" }}>
            <Col md={3}>
              <Avatar
                src={userDetails && userDetails.picUrl ? userDetails.picUrl : emptyImage}
                style={{
                  height: "60px",
                  width: "60px"
                }}
              />
            </Col>
            <Col md={16}>
              <Row>
                <Col md={24}>
                  {renderMemberStatusBadge(userDetails, t)}
                </Col>
                <Col md={24} className='mt-2'>
                  <span className='userLabel'>{t('User Id')}:</span>
                  <span style={{ marginLeft: "20px" }}>{userDetails && userDetails.memberId}</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className='mt-3' style={{ borderTopColor: "#636E88", borderTopStyle: "dashed", borderTopWidth: "1.5px", height: "20px" }}></div>
          <Row style={{ paddingLeft: "80px", paddingTop: "20px", paddingBottom: "15px", paddingRight: "70px" }}>
            <Col md={7}>{t('To manually set the membership period')}:</Col>
            <Col md={14} style={{ marginTop: "-8px" }}>
              <Row>
                <Col md={24}>
                  <Radio.Group onChange={onChange} value={dataObj.setMembership}>
                    <Space direction="vertical">
                      <Radio value="manually" style={{ width: "150px" }}><InputNumberComponent disabled={dataObj.setMembership === "manuallyDate" ? true : false} value={dataObj.manually} setValue={(value) => setDataObj({ ...dataObj, manually: value })} style={{ width: "100px", marginLeft: "10px" }} placeholder={t('Please select the number of days')} /></Radio>
                      <Radio value="manuallyDate" className='mt-3'>
                        <DateRangeComponent
                            format="YYYY-MM-DD"
                            style={{ width: "250px", marginLeft: "10px" }}
                            placeholder={t("Please select a time or time period")}
                            value={dates ? dates : [null, null]}
                            disabled={dataObj.setMembership === "manually" ? true : false}
                            setValue={setDates}
                          />
                        </Radio>
                    </Space>
                  </Radio.Group>
                </Col>
              </Row>
            </Col>
            <Col md={3} style={{ marginLeft: "-130px" }}>{t('day')}</Col>
            <Col md={7} className='mt-4'>
              <span><span style={{ color: "#e50a47" }}>* </span>{t('Remark')} ({t('reason_saved_to_history')}):</span>
            </Col>
            <Col md={17} className='mt-4'>
              <Col md={24}>
                <TextAreaComponent placeholder={t('enter_reason_manual_activation')} value={dataObj.remark} setValue={(value) => setDataObj({ ...dataObj, remark: value })} />
              </Col>
            </Col>
          </Row>
          <div className='d-flex justify-content-center mt-3'>
            <Button
              disabled={btnDisable ? false : true}
              style={{
                backgroundColor: "#E50A47",
                border: "none",
                color: "White",
                height: "45px",
                width: "230px",
                margin: "auto",
                borderRadius: "10px",
                fontSize: "16px",
                fontWeight: 500,
                opacity: btnDisable ? 1 : 0.5
              }}
              onClick={handleSubmitMembership}
            >
              {t("Confirm Submit")}
            </Button>
          </div>
          </Spin>
        </Modal>
      </Spin>
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* <UserProSvg /> */}
            <span style={{ marginLeft: "10px" }}>{t('Edit Basic Info')}</span>
          </div>
        }
        centered
        width={700}
        open={modalOpenNew}
        className='custom-modal'
        onOk={() => setModalOpenNew(false)}
        onCancel={() => setModalOpenNew(false)}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: "none" } }}
      >
        <Spin spinning={loading}>
        <Row className='mt-3 d-flex align-items-center' style={{ padding: "10px" }}>
          <Col md={4}>
            <div>
              <label htmlFor=''>{t('Phone Number')}</label>
            </div>
          </Col>
          <Col md={20} className='d-flex'>
            <Select
              className="selectCus"
              value={dataObjectNew.phone.countryCode}
              size="large"
              style={{
                width: 100,
              }}
              onChange={(value) => setDataObjectNew({
                ...dataObjectNew,
                phone: {
                  ...dataObjectNew.phone,
                  countryCode: value,
                },
              })}
              options={phoneData}
            />
            <InputMask
              key={dataObjectNew.phone.countryCode}
              value={dataObjectNew.phone.number}
              onChange={(event) => {
                setDataObjectNew({
                  ...dataObjectNew,
                  phone: {
                    ...dataObjectNew.phone,
                    number: event.target.value,
                  }
                });
                setIsChange(true);
              }}
              className={`inputCustomPho ${isSubmit && !dataObjectNew.phone.number && !dataObjectNew?.email || !dataObjectNew.phone.number && !dataObjectNew?.email ? 'input-error-cus' : ''}`}
              mask={dataObjectNew.phone.countryCode === "852" ? "9999-9999" : "999-9999-9999"}
            />
          </Col>
        </Row>
        <Row className='mt-1 d-flex align-items-center' style={{ padding: "10px" }}>
          <Col md={4}>
            <div>
              <label htmlFor=''>{t('employee_email')}</label>
            </div>
          </Col>
          <Col md={20} className='d-flex'>
            <InputComponent className={`mb-2`} status={isSubmit && !validateEmail(dataObjectNew?.email) || !dataObjectNew.phone.number && !dataObjectNew?.email ? `error` : ''} value={dataObjectNew.email}
                        setValue={(value) => setDataObjectNew({ ...dataObjectNew, email: value })} placeholder="" />
          </Col>
        </Row>
        <div className='text-center pt-3'>
          <Button
            style={{
              backgroundColor: "#e50a47",
              color: "white",
              height: "45px",
              width: "230px",
              fontWeight: 500,
              border: "none",
              fontSize: "16px"
            }}
            onClick={handleUpdate}
          >
            {t('update')}
          </Button>
        </div>
        </Spin>
      </Modal>
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </HeaderDetailComponent>
  );
}

export default UserDetailPage;
